<template>
    <div>
        <div class="layout">
            <div class="cabinet-page_bg"></div>

            <HeaderAuth/>
            <div class="cabinet-content-block-wrapper">
                <div class="cabinet-content-block">

                    <AdminNavigation/>
                    <div class="cabinet-content">
                        <div class="heading-wrapper">
                            <div class="title" v-html="$ml.with('VueJS').get('clients')"></div>

                            <div class="filter-block">

                                <div class="search-row">
                                    <div class="form">
                                        <div class="form-field-input-3">
                                            <div class="field-input-wrapper">
                                                <input v-model="substr" @input="inputChanged" type="text" class="field-search" placeholder="Поиск...">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="checkbox-block">
                                    <div class="checkbox-row">
                                        <div class="filter-check">
                                            <label>
                                                <span class="field-check-wrapper">
                                                    <input v-model="checkedStatuses.NOT_SUBSCRIBED"
                                                           @change="inputChanged"
                                                           type="checkbox"
                                                    >
                                                    <span class="field-check"></span>
                                                </span>
                                                <span>Без подписки</span>
                                            </label>
                                        </div>
                                        <div class="filter-check">
                                            <label>
                                        <span class="field-check-wrapper">
                                            <input v-model="checkedStatuses.SUBSCRIBED"
                                                   @change="inputChanged"
                                                   type="checkbox"
                                            >
                                            <span class="field-check"></span>
                                        </span>
                                                <span>С подпиской</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="checkbox-row">
                                        <div class="filter-check">
                                            <label>
                                                <span class="field-check-wrapper">
                                                    <input v-model="checkedStatuses.WAIT_VERIFICATION"
                                                           @change="inputChanged"
                                                           type="checkbox"
                                                    >
                                                    <span class="field-check"></span>
                                                </span>
                                                <span>Ожидает проверки</span>
                                            </label>
                                        </div>
                                        <div class="filter-check">
                                            <label>
                                                <span class="field-check-wrapper">
                                                    <input v-model="checkedStatuses.WAIT_SEND"
                                                           @change="inputChanged"
                                                           type="checkbox"
                                                    >
                                                    <span class="field-check"></span>
                                                </span>
                                                <span>Ожидает отправки</span>
                                            </label>
                                        </div>
                                        <div class="filter-check">
                                            <label>
                                                <span class="field-check-wrapper">
                                                    <input v-model="checkedStatuses.MAILS_SENT"
                                                           @change="inputChanged"
                                                           type="checkbox"
                                                    >
                                                    <span class="field-check"></span>
                                                </span>
                                                <span>Письма отправлены</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="cabinet-content-inner">

                            <div class="clients-list">
                                <template v-for="client in clients">
                                    <router-link :to="'client?id=' + client.id" v-if="client.status === 'waitVerification' || client.status === 'waitSend'" class="clients-item">
                                        <span class="name">{{ client.fullname }}</span>
                                        <span class="client-status" :class="getClassName(client.status)"
                                              v-html="$ml.with('VueJS').get(client.status)">
                                        </span>
                                    </router-link>
                                    <div v-else class="clients-item">
                                        <span class="name">{{ client.fullname }}</span>
                                        <span class="client-status" :class="getClassName(client.status)"
                                              v-html="$ml.with('VueJS').get(client.status)">
                                        </span>
                                    </div>
                                </template>
                            </div>

                            <div v-show="pageCount > 1" class="pagination">
                                <ul>
                                    <li class="nav nav-first" :class="{'disabled' : pageNumber === 1}" @click="goToPage(1)"><span><ArrowFirstIcon/></span></li>
                                    <li class="nav nav-prev" :class="{'disabled' : pageNumber === 1}" @click="goToPage(pageNumber - 1)"><span><ArrowPrevIcon/></span></li>
                                    <li v-for="i in pagesToShow" :class="{'active' : i === pageNumber}" @click="goToPage(i)">
                                        <span v-if="i === pageNumber">{{i}}</span>
                                        <a v-else>{{i}}</a>
                                    </li>
                                    <li class="nav nav-next" :class="{'disabled' : pageNumber === pageCount}" @click="goToPage(pageNumber + 1)"><span><ArrowPrevIcon/></span></li>
                                    <li class="nav nav-last" :class="{'disabled' : pageNumber === pageCount}" @click="goToPage(pageCount)"><span><ArrowFirstIcon/></span></li>
                                </ul>
                            </div>

                        </div>
                    </div>

                </div>
            </div>

        </div>
        <FooterAuth/>
    </div>
</template>


<script>

import FooterAuth from "../../components/FooterAuth";
import HeaderAuth from "../../components/HeaderAuth";
import AdminNavigation from "../../components/AdminNavigation";
import rest from "../../restUtils";
import ArrowFirstIcon from "@/components/icons/ArrowFirstIcon";
import ArrowPrevIcon from "@/components/icons/ArrowPrevIcon";

export default {
    name: 'Clients',
    components: {ArrowPrevIcon, ArrowFirstIcon, AdminNavigation, HeaderAuth, FooterAuth},
    metaInfo: {
        title: 'Клиенты | Your Last Word'
    },

    data() {
        return {
            checkedStatuses: {
                NOT_SUBSCRIBED: true,
                SUBSCRIBED: true,
                WAIT_VERIFICATION: true,
                WAIT_SEND: true,
                MAILS_SENT: true
            },
            substr: '',
            clients: [],
            totalSize: 0,
            countOnPage: 20,
            pageNumber: 1,
            pageCount: 1
        }
    },

    beforeCreate() {
        $('body').attr('class', 'cabinet-page');
    },

    async created() {
        await this.loadClients(1);

        let socialToken = this.$route.query.socialToken;
        if (!!socialToken) {
            let query = Object.assign({}, this.$route.query);
            delete query.socialToken;
            this.$router.replace({query});
            await this.$store.dispatch('changeLanguage', this.$ml.current);
        }
    },

    computed: {
        pagesToShow() {
            let result = [];
            if (this.pageCount < 5) {
                for (let i = 0; i < this.pageCount; i++) {
                    result[i] = i + 1;
                }
            } else {
                let start = this.pageNumber;
                let finish = start + 5;
                if (finish > this.pageCount) {
                    start = this.pageCount - 4;
                }
                for (let i = 0; i < 5; i++) {
                    result[i] = start + i;
                }
            }
            return result;
        }
    },

    methods: {
        async loadClients(pageNumber) {
            let statuses = [];
            for (let key in this.checkedStatuses) {
                // eslint-disable-next-line no-prototype-builtins
                if (this.checkedStatuses.hasOwnProperty(key)) {
                    if (this.checkedStatuses[key]) {
                        statuses.push(key);
                    }
                }
            }

            let dto = {
                substr: this.substr,
                statuses: statuses,
                page: pageNumber
            }

            let response = await rest.doPost("/admin/clients", dto);
            this.clients = response.clients;
            this.totalSize = response.size;
            this.countOnPage = response.countOnPage;

            this.pageCount = Math.ceil(this.totalSize / this.countOnPage);
        },

        inputChanged() {
            this.pageNumber = 1;
            this.loadClients(1);
        },

        getClassName(statusCode) {
            switch (statusCode) {
                case "subscribed":
                    return "status__payed";
                case "waitVerification":
                    return "status__check";
                case "waitSend":
                    return "status__wait";
                case "mailsSent":
                    return "status__send";
                default:
                    return "status__free";
            }
        },

        goToPage(pageNumber) {
            if (pageNumber >= 1 && pageNumber <= this.pageCount) {
                this.pageNumber = pageNumber;
                this.loadClients(pageNumber);
            }
        }
    }
}

</script>

